<template>
  <b-card
    class="px-1 m-0"
  >
    <div style="padding: 3% 30% 5% 30%;">
      <b-card-title
        title-tag="h2"
        class="font-weight-bolder text-colorBlack mb-50 mt-2 pr-5 mr-5"
      >
        Set new password
      </b-card-title>
      <b-card-text class="text-colorGray" style="font-size: 0.8rem">
        Please enter and re-enter your new password
      </b-card-text>

      <validation-observer ref="loginFormValidation">
        <b-form class="auth-login-form mt-2" @submit.prevent>
          <b-form-group label-for="current_password">
            <validation-provider
              #default="{ errors }"
              name="Current Password"
              rules="required"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="current_password"
                  v-model="current_password"
                  :state="errors.length > 0 ? false : null"
                  class="form-control-merge"
                  :type="passwordFieldType"
                  name="current_password"
                  placeholder="Current Password"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    class="cursor-pointer"
                    :icon="passwordToggleIcon"
                    @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group label-for="password">
            <validation-provider
              #default="{ errors }"
              name="New Password"
              rules="required"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="password"
                  v-model="password"
                  :state="errors.length > 0 ? false : null"
                  class="form-control-merge"
                  :type="passwordFieldType"
                  name="password"
                  placeholder="New Password"
                  :disabled="current_password ? false:true"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    class="cursor-pointer"
                    :icon="passwordToggleIcon"
                    @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>


          <b-form-group label-for="ReEnterpassword" class="mt-2">
            <validation-provider
              #default="{ errors }"
              name="Re Enter password"
              rules="required"
            >
              <b-input-group
                class="input-group-merge"
                :class="errors.length > 0 ? 'is-invalid' : null"
              >
                <b-form-input
                  id="reEnterPassword"
                  v-model="reEnterPassword"
                  :state="errors.length > 0 ? false : null"
                  class="form-control-merge"
                  :type="passwordFieldType"
                  name="password"
                  placeholder="Re Enter Password"
                  :disabled="current_password ? false:true"
                />
                <b-input-group-append is-text>
                  <feather-icon
                    class="cursor-pointer"
                    :icon="passwordToggleIcon"
                    @click="togglePasswordVisibility"
                  />
                </b-input-group-append>
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-form>
      </validation-observer>
      <b-button
        class="mt-3"
        type="submit"
        variant="primary"
        block        
        @click="validateForm"
        :disabled="current_password && password && reEnterPassword ? false:true"
      >
        Update Password
      </b-button>
    </div>
  </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import { $themeConfig } from "@themeConfig";
import { mapActions, mapGetters } from "vuex";
import util from "@/util.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility, util],
  data() {
    return {
      appName: "",
      appFullName: "",
      appFullName: "",
      current_password: "",
      password: "",
      reEnterPassword: "",
      required,
    };
  },
  created() {
    this.appName = $themeConfig.app.appName;
    this.appFullName = $themeConfig.app.appFullName;
    this.appLogoImage = $themeConfig.app.appLogoImage;
  },
  methods: {
    ...mapActions({ 
      login: "appData/login",
      changePassword: "appData/changePassword",
    }),
    async validateForm() {
      const success = await this.$refs.loginFormValidation.validate();
      if (success) {
        await this.submit();
      }
    },
    async submit() {
      try {
        
        if (this.password === this.reEnterPassword){
          const res = await this.changePassword({
            payload: {
                "old_password": this.current_password,
                "new_password": this.password,
                "confirm_new_password": this.reEnterPassword
              }
            }
          );
          if (res.status === 200) {
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "Password Changed Successfully",
                  variant: "success",
                  icon: "BellIcon",
                },
              },
              {
                position: "top-right",
              }
            );
            this.$router.push({ name: "Dashboard" });
          }
          else{
            console.log(res);
          }
        }
        else
        {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "New Password and ReType Password doesn't match",
                variant: "danger",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
        }
        
      } catch (error) {
        this.displayError(error);
      }
    },
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    ...mapGetters({ hasRole: "appData/hasRole", getLoggedInUser: "appData/getLoggedInUser" }),
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>

<style scoped></style>

